import { render, staticRenderFns } from "./transportationModelEdit.vue?vue&type=template&id=fc74f0ea&scoped=true"
import script from "./transportationModelEdit.vue?vue&type=script&lang=js"
export * from "./transportationModelEdit.vue?vue&type=script&lang=js"
import style0 from "./transportationModelEdit.vue?vue&type=style&index=0&id=fc74f0ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc74f0ea",
  null
  
)

export default component.exports